export default "__VITE_ASSET__575503d8__"